var _rect, _path, _circle, _circle2, _circle3, _rect2, _circle4, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlidein = function SvgSlidein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 42,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 42,
    fill: "#EAEDF1",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 3a3 3 0 0 1 3-3h48a3 3 0 0 1 3 3v3H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    x: 27,
    y: 23,
    fill: "#666",
    rx: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 26,
    r: 1,
    fill: "#EAEDF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 3,
    x: 30,
    y: 34,
    fill: "#EAEDF1",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 34,
    y: 28,
    fill: "#EAEDF1",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 3,
    x: 43,
    y: 34,
    fill: "#EAEDF1",
    rx: 1.5
  })));
};
export { SvgSlidein as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA1NCA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjU0IiBoZWlnaHQ9IjQyIiByeD0iMyIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cGF0aCBkPSJNMCAzQzAgMS4zNDMxNSAxLjM0MzE1IDAgMyAwSDUxQzUyLjY1NjkgMCA1NCAxLjM0MzE1IDU0IDNWNkgwVjNaIiBmaWxsPSIjNjY2NjY2Ij48L3BhdGg+CjxjaXJjbGUgY3g9IjMiIGN5PSIzIiByPSIwLjUiIGZpbGw9InZhcigtLWdyb290LXByaW1hcnkwMDMpIiBzdHJva2U9IiNFQUVERjEiPjwvY2lyY2xlPgo8Y2lyY2xlIGN4PSI2IiBjeT0iMyIgcj0iMC41IiBmaWxsPSJ2YXIoLS1ncm9vdC1wcmltYXJ5MDAzKSIgc3Ryb2tlPSIjRUFFREYxIj48L2NpcmNsZT4KPGNpcmNsZSBjeD0iOSIgY3k9IjMiIHI9IjAuNSIgZmlsbD0idmFyKC0tZ3Jvb3QtcHJpbWFyeTAwMykiIHN0cm9rZT0iI0VBRURGMSI+PC9jaXJjbGU+CjxyZWN0IHg9IjI3IiB5PSIyMyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjE2IiByeD0iMiIgZmlsbD0iIzY2NjY2NiI+PC9yZWN0Pgo8Y2lyY2xlIGN4PSI0OCIgY3k9IjI2IiByPSIxIiBmaWxsPSIjRUFFREYxIj48L2NpcmNsZT4KPHJlY3QgeD0iMzAiIHk9IjM0IiB3aWR0aD0iMTEiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cmVjdCB4PSIzNCIgeT0iMjgiIHdpZHRoPSIxMCIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cmVjdCB4PSI0MyIgeT0iMzQiIHdpZHRoPSI1IiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiNFQUVERjEiPjwvcmVjdD4KPC9zdmc+";